import React, { useEffect, useState } from "react";
import {
  bgColor07,
  bgColor15,
  blackColor,
  blackShade19,
  blackShade21,
  blueColor04,
  greenColor,
  greenStatusColor01,
  greyColor060,
  greyColor21,
  lightgreenColor04,
  lightRedColor,
  progressBGColor,
  redColor,
  whiteColor,
  yellowColor01,
  yellowColorBG03,
} from "../../configs/styles/muiThemes";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  selectAllProductRows,
  toggleProductRowSelect,
} from "../../reducers/catalogBulkUploadCopy/catalogBulkUploadSlice";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import { useNavigate } from "react-router-dom";
import { textTwoLines } from "../../utils/styles";
import EmptyCatalogData from "../CatalogBulkUploadNewCopy/Components/EmptyCatalogData";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import PriceInputBox from "./components/PriceInputBox";
import ErrorToolTipIcon from "../CatalogBulkUploadNewCopy/Components/ErrorToolTipIcon";

export const BULK_INVENTORY_TABLE_HEADER = [
  { id: "01", title: "S.No", col: 0.3 },
  { id: "02", title: "Product Info", col: 6 },
  { id: "03", title: "Available Qty", col: 1.3 },
  { id: "05", title: "Original Price", col: 1.3 },
  { id: "06", title: "Sale Price", col: 1.3 },
  { id: "07", title: "Discount", col: 1 },
  { id: "08", title: "Action", col: 0.8 },
];

export const BULK_INVENTORY_TABLE_HEADER_CATALOG_PARTNER = [
  { id: "01", title: "S.No", col: 0.3 },
  { id: "02", title: "Product Info", col: 5.8 },
  { id: "03", title: "SKU Code", col: 1.5 },
  { id: "05", title: "Original Price", col: 1.3 },
  { id: "06", title: "Sale Price", col: 1.3 },
  { id: "07", title: "Discount", col: 1 },
  { id: "08", title: "Action", col: 0.8 },
];

const ReviewInventoryDetails = React.memo(
  ({
    isCatalogPartner,
    productDetails,
    setProductDetails,
    isLoading,
    selectedRowCount,
    setCurrentPage,
    selectAllProductRows,
    toggleProductRowSelect,
    deleteRows,
  }) => {
    const [tableHeader, setTableHeader] = useState(BULK_INVENTORY_TABLE_HEADER);

    //handle table cell value change
    const handleValueChange = (key, value, index) => {
      let allProducts = [...productDetails];

      const errors = { ...allProducts[index]?.errors };
      delete errors[key];

      allProducts[index] = {
        ...allProducts[index],
        // isSelected: true,
        [key]: value,
        errors: errors,
      };
      setProductDetails((prevState) => allProducts);
    };

    const calculateDiscount = (originalPrice, salePrice) => {
      if (originalPrice <= 0) return 0;
      const percentage = ((originalPrice - salePrice) / originalPrice) * 100;
      return percentage.toFixed(2) > 0 ? percentage.toFixed(2) : 0;
    };

    //handle single product delete
    const singleRowDelete = (id) => {
      deleteRows([id]);
    };

    //handle delete Selected Rows
    const deleteSelectedRows = () => {
      const rowIds = productDetails
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.id);

      console.log("rowIds", rowIds);

      deleteRows(rowIds);
    };

    // get border color for error lines
    const getBorderColor = (item, index) => {
      if (item?.errors && Object.keys(item?.errors).length > 0) {
        return {
          borderBottom: `1px solid rgba(187, 80, 80, 0.56)`,
          bgcolor: "#fff5f560",
        };
      }

      return { bgcolor: index % 2 == 0 ? whiteColor : bgColor07 };
    };

    useEffect(() => {
      setTableHeader(
        isCatalogPartner
          ? BULK_INVENTORY_TABLE_HEADER_CATALOG_PARTNER
          : BULK_INVENTORY_TABLE_HEADER
      );
      return () => {};
    }, [isCatalogPartner]);

    return (
      <Box>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography sx={styles.heading}>
              Review & Update{" "}
              {isCatalogPartner ? "Pricing" : "Inventory/Pricing"} Details
            </Typography>

            {productDetails?.length > 0 && (
              <Typography sx={styles.subHeading}>
                {selectedRowCount} of {productDetails?.length} rows selected for
                updates and import
              </Typography>
            )}
          </Box>

          {/* {productDetails?.some((item) => item.isSelected) && (
            <Button
              variant="outlined"
              sx={styles.deleteBtn}
              onClick={deleteSelectedRows}
            >
              Delete Selected Rows
            </Button>
          )} */}
        </Box>

        {isLoading ? (
          <ThreeDotLoader />
        ) : productDetails?.length > 0 ? (
          <Box
            sx={{
              border: `1px solid ${progressBGColor}`,
              borderRadius: "10px",
              mt: 1,
            }}
          >
            <Box borderBottom={`1px solid ${progressBGColor}`} p="6px 10px">
              <Grid container spacing={2}>
                {tableHeader?.map((item, index) => (
                  <Grid key={item.id} item md={item.col}>
                    {index === 0 ? (
                      <Checkbox
                        // size=""
                        checked={productDetails?.every(
                          (item) => item.isSelected
                        )}
                        onChange={({ target }) => {
                          selectAllProductRows(target.checked);
                        }}
                        sx={styles.checkbox}
                      />
                    ) : (
                      <Typography
                        fontSize={12}
                        fontWeight={400}
                        color={greyColor060}
                      >
                        {item.title}
                      </Typography>
                    )}
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box sx={styles.listContainer}>
              {productDetails?.map((item, index) => (
                <Box
                  key={`sku_${index}`}
                  // bgcolor={index % 2 == 0 ? whiteColor : bgColor07}
                  // borderBottom={getBorderColor(item)}
                  p="10px 10px 10px 10px"
                  sx={{ ...getBorderColor(item, index) }}
                >
                  <Grid container spacing={2}>
                    <Grid item md={0.3}>
                      <Checkbox
                        // size=""
                        checked={item?.isSelected || false}
                        onChange={() => {
                          toggleProductRowSelect(index, item?.isSelected);
                        }}
                        sx={styles.checkbox}
                      />
                    </Grid>

                    <Grid item md={isCatalogPartner ? 5.8 : 6}>
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1.5}
                        position="relative"
                      >
                        {item?.errors?.productId && (
                          <Box
                            sx={{
                              position: "absolute",
                              right: -0,
                              top: -18,
                              zIndex: 1,
                            }}
                          >
                            <ErrorToolTipIcon
                              errorMsg={item?.errors?.productId}
                              width="150px"
                            />
                          </Box>
                        )}
                        <Box sx={styles.imgBox}>
                          <Box
                            component="img"
                            src={item?.originalProdInfo?.productPhoto?.docURL}
                            sx={styles.imgContainer}
                          />
                        </Box>

                        <Box flex={1}>
                          <Typography
                            fontSize={12}
                            fontWeight={600}
                            color={blackColor}
                            lineHeight="20px"
                            title={item?.productName}
                            sx={{ ...textTwoLines }}
                          >
                            {item?.productName}
                          </Typography>

                          {!isCatalogPartner && (
                            <Typography
                              fontSize={10.5}
                              fontWeight={500}
                              color={bgColor15}
                              lineHeight="20px"
                            >
                              Min Order Qty:{" "}
                              <Typography
                                component="span"
                                fontSize={10.5}
                                fontWeight={600}
                              >
                                {item?.originalProdInfo?.minOrderQuantity}
                              </Typography>
                              , Max Order Qty:{" "}
                              <Typography
                                component="span"
                                fontSize={10.5}
                                fontWeight={600}
                              >
                                {item?.originalProdInfo?.maxOrderQuantity}
                              </Typography>
                              , Alert Qty:{" "}
                              <Typography
                                component="span"
                                fontSize={10.5}
                                fontWeight={600}
                              >
                                {item?.originalProdInfo?.alertQuantity}
                              </Typography>
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Grid>

                    {isCatalogPartner ? (
                      <Grid item md={isCatalogPartner ? 1.45 : 1.3}>
                        <Box >
                          <Typography
                            fontSize={11.5}
                            fontWeight={600}
                            color={blackShade19}
                            lineHeight="20px"
                          >
                            {item?.skuCode}
                          </Typography>
                        </Box>
                      </Grid>
                    ) : (
                      <Grid item md={1.3}>
                        <Box position="relative">
                          <PriceInputBox
                            minWidth="100px"
                            width="100px"
                            value={item?.availableQuantity}
                            onValueChange={(value) => {
                              handleValueChange(
                                "availableQuantity",
                                value,
                                index
                              );
                            }}
                            regexType="qty"
                            errorMsg={item?.errors?.availableQuantity}
                            bgcolor={index % 2 == 0 ? whiteColor : bgColor07}
                            textColor={
                              Number(
                                item?.originalProdInfo?.availableQuantity || 0
                              ) != Number(item?.availableQuantity)
                                ? blueColor04
                                : ""
                            }
                            fontWeight={
                              Number(
                                item?.originalProdInfo?.availableQuantity || 0
                              ) != Number(item?.availableQuantity)
                                ? 600
                                : 500
                            }
                            textAlign="right"
                          />
                        </Box>

                        <CurrentValue
                          value={item?.originalProdInfo?.availableQuantity}
                        />
                      </Grid>
                    )}

                    <Grid item md={1.3}>
                      <Box position="relative">
                        <PriceInputBox
                          minWidth="80px"
                          width="100px"
                          value={item?.productOriginalPrice}
                          onValueChange={(value) => {
                            handleValueChange(
                              "productOriginalPrice",
                              value,
                              index
                            );
                          }}
                          regexType="qty"
                          errorMsg={item?.errors?.productOriginalPrice}
                          bgcolor={index % 2 == 0 ? whiteColor : bgColor07}
                          textColor={
                            Number(
                              item?.originalProdInfo?.productOriginalPrice || 0
                            ) != Number(item?.productOriginalPrice)
                              ? blueColor04
                              : ""
                          }
                          fontWeight={
                            Number(
                              item?.originalProdInfo?.productOriginalPrice || 0
                            ) != Number(item?.productOriginalPrice)
                              ? 600
                              : 500
                          }
                          textAlign="right"
                        />
                      </Box>

                      <CurrentValue
                        value={`₹${item?.originalProdInfo?.productOriginalPrice}`}
                      />
                    </Grid>

                    <Grid item md={1.3}>
                      <Box position="relative">
                        <PriceInputBox
                          minWidth="80px"
                          width="100px"
                          value={item?.productSalePrice}
                          onValueChange={(value) => {
                            handleValueChange("productSalePrice", value, index);
                          }}
                          regexType="qty"
                          errorMsg={item?.errors?.productSalePrice}
                          bgcolor={index % 2 == 0 ? whiteColor : bgColor07}
                          textColor={
                            Number(
                              item?.originalProdInfo?.productSalePrice || 0
                            ) != Number(item?.productSalePrice)
                              ? blueColor04
                              : ""
                          }
                          fontWeight={
                            Number(
                              item?.originalProdInfo?.productSalePrice || 0
                            ) != Number(item?.productSalePrice)
                              ? 600
                              : 500
                          }
                          textAlign="right"
                        />
                      </Box>

                      <CurrentValue
                        value={`₹${item?.originalProdInfo?.productSalePrice}`}
                      />
                    </Grid>

                    <Grid item md={0.8}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Box
                          sx={{
                            fontSize: 11.5,
                            fontWeight: 500,
                            color: greenStatusColor01,
                            bgcolor: lightgreenColor04,
                            padding: "2px 5px",
                            borderRadius: "4px",
                            lineHeight: "18px",
                          }}
                        >
                          {calculateDiscount(
                            Number(item?.productOriginalPrice || 0),
                            Number(item?.productSalePrice || 0)
                          )}
                        </Box>
                      </Box>
                    </Grid>

                    <Grid item md={1}>
                      <Box
                        minWidth="50px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1.5}
                      >
                        <Stack alignItems="center" justifyContent="center">
                          {item?.errors &&
                          Object.keys(item?.errors).length > 0 ? (
                            <Box sx={styles.errorCountTag}>
                              {Object.keys(item?.errors).length}
                            </Box>
                          ) : (
                            <CheckCircleIcon
                              sx={{ fontSize: 16, color: greenColor }}
                            />
                          )}
                        </Stack>

                        {/* <IconButton
                          size="small"
                          onClick={() => {
                            singleRowDelete(item?.id);
                          }}
                          sx={{ p: 0 }}
                        >
                          <DeleteIcon
                            sx={{ fontSize: "16px", color: redColor }}
                          />
                        </IconButton> */}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          <EmptyCatalogData
            message="Inventory/Pricing details not uploaded. Please make sure the data is in the required format"
            goBack={() => {
              setCurrentPage("upload");
            }}
            btnText="Go to Upload File"
          />
        )}
      </Box>
    );
  }
);

export default ReviewInventoryDetails;

const CurrentValue = ({ value }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mt={0.8}
    >
      <Typography fontSize={11} fontWeight={500} color={blackShade19}>
        Current
      </Typography>

      <Box
        sx={{
          fontSize: 10.5,
          fontWeight: 500,
          color: yellowColor01,
          lineHeight: "20px",
          p: "0px 10px",
          borderRadius: "50px",
          bgcolor: yellowColorBG03,
        }}
      >
        {value}
      </Box>
    </Box>
  );
};

const QtyLabelValue = ({ label, value }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={0.2}
    >
      <Typography
        fontSize={10.5}
        fontWeight={400}
        color={blackShade19}
        lineHeight="18px"
      >
        {label}
      </Typography>

      <Typography
        fontSize={10.5}
        fontWeight={500}
        color={blackShade19}
        lineHeight="18px"
      >
        {value}
      </Typography>
    </Box>
  );
};

const styles = {
  heading: {
    fontSize: "14px",
    fontWeight: "600",
    color: blackShade19,
    mb: 0.2,
  },
  subHeading: {
    fontSize: "13px",
    fontWeight: "400",
    color: blackShade21,
  },

  listContainer: {
    height: "42vh",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "2px",
      height: "2px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: blueColor04,
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  imgBox: {
    width: { xs: "25px", md: "40px !important" },
    height: { xs: "25px", md: "40px !important" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    border: "1px solid #e5e9f0",
    // p: "5px",
    cursor: "pointer",
  },

  imgContainer: {
    backgroundColor: whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: { xs: "25px", md: "34px !important" },
    height: { xs: "25px", md: "34px !important" },
    objectFit: "contain",
  },

  checkbox: {
    color: greyColor21,
    p: 0,
    mt: -0.5,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: blueColor04,
    },
  },

  errorCountTag: {
    backgroundColor: lightRedColor,
    color: redColor,
    fontSize: 12,
    fontWeight: 600,
    p: "3px 18px",
    borderRadius: "10px",
  },

  deleteBtn: {
    fontSize: 11,
    fontWeight: 600,
    color: redColor,
    border: `1px solid ${redColor}`,

    "&:hover": {
      color: whiteColor,
      bgcolor: redColor,
      border: `1px solid ${redColor}`,
    },
  },
};
